import CartUtils from "../services/Cart/CartUtils";

export const getFreeDeliveryPrice = (session: any) => session.free_delivery_price_money?.amount;

const getCreditPromotionValue = (cart: any) => CartUtils.getCreditValue(cart);

const getDiscountDelivery = (cart: any) => cart.discount_delivery_fee ? cart.discount_delivery_fee.amount : 0;

export const getCartPrice = (cart: any) => cart.items_with_discount_price?.amount || 0;

export const getToFreeDeliveryPrice = (session: any, cart: any) =>
    getFreeDeliveryPrice(session) - getCartPrice(cart) - getCreditPromotionValue(cart) + getDiscountDelivery(cart);